module.exports = __webpack_public_path__ + "media/images/redesign-images/about-us/group-photo-4ce9a44a4df0ba79e6e98a9ee55d0b98.jpg";